import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import PriceVatDisclaimer from 'common/PriceVatDisclaimer';


const rows = [
  {
    supercines: 'Spot cinematográfico (20”) con voz de MEM',
    tno: 'Espacios y menciones en Conexión MEM dedicados a Supercines',
    usd: 150,
  },
  {
    supercines: 'Presencia de marca en pantallas y lobbies',
    tno: 'Cápsulas Supercines Flash-Top y Primer Plano Supercines en Streaming y On-Demand',
    usd: 150,
  },
  {
    supercines: 'Mención de TNO como aliado en premieres y activaciones',
    tno: 'Sección editorial Butaca Digest por Supercines y cobertura de cartelera con enfoque SEO',
    usd: 100,
  },
];

const ArchitectureSummary = () => {
  const theme = useTheme();
  const totalUsd = rows.reduce((acc, r) => acc + (Number(r.usd) || 0), 0);

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color="primary"
          align="center"
        >
          Arquitectura de la Alianza
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h4"
          gutterBottom
          align="center"
          color="primary"
        >
          Intercambio de alto valor Supercines x TNO
        </Box>
        <Typography
          variant="body2"
          color="textSecondary"
          align="center"
          sx={{ maxWidth: 720, mx: 'auto' }}
        >
          Una arquitectura clara y accionable donde cada presencia de Supercines en sala tiene su reflejo
          inmediato en el ecosistema digital de TNO Network.
        </Typography>
      </Box>

      <TableContainer
        component={Paper}
        elevation={2}
        sx={{ maxWidth: 900, mx: 'auto', borderRadius: 2 }}
      >
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: theme.palette.primary.main }}>
              <TableCell sx={{ color: 'white', fontWeight: 700 }}>
                Espacios de Supercines
              </TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 700 }}>
                Entrega de TNO Network
              </TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 700 }} align="right">
                Inversión (USD)
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, i) => (
              <TableRow key={i} hover>
                <TableCell>{row.supercines}</TableCell>
                <TableCell>{row.tno}</TableCell>
                <TableCell align="right">${row.usd}</TableCell>
              </TableRow>
            ))}
            <TableRow sx={{ bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50' }}>
              <TableCell colSpan={2} sx={{ fontWeight: 700 }}>
                Total
              </TableCell>
              <TableCell align="right" sx={{ fontWeight: 700 }}>
                ${totalUsd}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <PriceVatDisclaimer />
    </Box>
  );
};

export default ArchitectureSummary;

